/** @enum {string} */
const CanvasEvents = Object.freeze({
    DRAW_IMAGE: "drawImage"
})

export default CanvasEvents;